import React, { useState, useEffect } from 'react';
import { FileText, Shield, Users, Lock, Loader } from 'lucide-react';
import { getPageBySlug } from '../lib/pageService';

const KVKKAydinlatmaMetni = () => {
  const [pageContent, setPageContent] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        setIsLoading(true);
        const page = await getPageBySlug('kvkk-aydinlatma-metni');
        if (page && page.content) {
          setPageContent(page.content);
        } else {
          setError('Sayfa içeriği bulunamadı.');
        }
      } catch (err) {
        console.error('Error fetching page content:', err);
        setError('Sayfa içeriği yüklenirken bir hata oluştu.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPageContent();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex items-center gap-3">
          <Loader className="w-6 h-6 text-[#F7BA45] animate-spin" />
          <span className="text-slate-600">Sayfa yükleniyor...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-gradient-to-b from-[#F7BA45]/20 to-slate-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6 text-center">
              KVKK Aydınlatma Metni
            </h1>
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-slate-200">
              {pageContent ? (
                <div dangerouslySetInnerHTML={{ __html: pageContent }} />
              ) : error ? (
                <div className="text-center text-red-500">
                  <p>{error}</p>
                </div>
              ) : (
                <div className="prose prose-slate max-w-none">
                  <div className="flex items-start gap-4 mb-8">
                    <div className="bg-[#F7BA45]/10 p-3 rounded-lg flex-shrink-0">
                      <FileText className="w-6 h-6 text-[#F7BA45]" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-semibold text-slate-800 mb-4">Veri Sorumlusu</h2>
                      <p className="text-slate-600 leading-relaxed">
                        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, Technoworks Bilgi Teknolojileri A.Ş. olarak, veri sorumlusu sıfatıyla, kişisel verilerinizi aşağıda açıklanan amaçlar kapsamında hukuka ve dürüstlük kurallarına uygun bir şekilde işleyebilir, kaydedebilir, saklayabilir, sınıflandırabilir, güncelleyebilir ve mevzuatın izin verdiği hallerde üçüncü kişilere açıklayabilir/aktarabiliriz.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KVKKAydinlatmaMetni;